module.exports = __webpack_public_path__ + "img/c4a580165f984a93a62b12bfd1249ace-1024.a3763abd.jpg";